export type StrategyReviewAction = "approve" | "approved" | "blocked";

export function strategyReviewAction(status: string): StrategyReviewAction {
  if (status === "awaiting_approval") return "approve";
  if (status === "approved") return "approved";
  return "blocked";
}

export function strategyReviewStatusLabel(status: string): string {
  return status === "approved" ? "Creative Strategy approved" : status.replaceAll("_", " ");
}
